<template>
  <div id="ranking" class="w-full h-screen bg-black text-white overflow-scroll">
    <div type="flex" justify="center" align="middle" class="title-row">

      `<div class="title">
        <div class="flex justify-between">
          <div class="text-left leading-snug text-2xl md:text-5xl py-3 pl-10 md:pl-40">{{title}} ランキングTop10</div>
          <div class="disp-btn p-5 pr-5 md:pr-28">
            <!-- <el-button v-if="dispNum > 0" @click="reduceDispNum" class="bg-white text-black" size="large" type="info" :icon="Trophy" circle /> -->
            <button class="w-14 py-2 flex justify-center rounded-full bg-gray-500 text-white border border-gray-500 hover:bg-gray-400 hover:text-white" size="mini" v-if="dispNum > 0" @click="reduceDispNum" circle>
              <svg style="width:35px;height:35px" viewBox="0 0 24 24">
                <path fill="currentColor" d="M17 4V2H7V4H2V11C2 12.1 2.9 13 4 13H7.1C7.5 14.96 9.04 16.5 11 16.9V19.08C8 19.54 8 22 8 22H16C16 22 16 19.54 13 19.08V16.9C14.96 16.5 16.5 14.96 16.9 13H20C21.1 13 22 12.1 22 11V4H17M4 11V6H7V11L4 11M15 12C15 13.65 13.65 15 12 15S9 13.65 9 12V4H15V12M20 11L17 11V6H20L20 11Z" />
              </svg>
            </button>
          </div>
        </div>
        <hr>
      </div>`
    </div>
    <div class="flex justify-center">
      <div class="w-full md:w-1/2">
        <div v-for="(item, index) in userProfitloss" :key="item.id" class="grid grid-cols-10 gap-2 flex items-center">
          <div class="col-span-3 ml-2 flex justify-center">
            <template v-if="item.rank_num==1">
              <div class="medal my-2 md:my-3">
                <img class="object-contain h-14 md:h-20 w-14 md-20" src="@/assets/images/tools/survey/kojirokousi_gold.png" alt="金メダル">
              </div>
            </template>
            <template v-else-if="item.rank_num==2">
              <div class="medal my-2 md:my-3 flex justify-center">
                <img class="object-contain h-14 md:h-20 w-14 md-20" src="@/assets/images/tools/survey/kojirokousi_silver.png" alt="銀メダル">
              </div>
            </template>
            <template v-else-if="item.rank_num==3">
              <div class="medal my-2 md:my-3 flex justify-center">
                <img class="object-contain h-14 md:h-20 w-14 md-20" src="@/assets/images/tools/survey/kojirokousi_bronze.png" alt="銅メダル">
              </div>
            </template>
            <template v-else>
              <div class="text-2xl md:text-4xl my-3 md:my-4 flex justify-center">
                {{ item.rank_num }}位
              </div>
            </template>
          </div>
          <div class="col-span-7">
            <div  class="pb-2 text-left text-2xl md:text-4xl flex items-center animate__animated animate__fadeInRight flex flex-wrap" v-if="index >= dispNum">
              {{ item.nickname }}さん<br>
              <div :class="`pl-5 sign${Math.sign(item.total_profitloss)}`">{{ addComma(item.total_profitloss) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { axios } from '@/plugins/axios'
import { Trophy } from '@element-plus/icons-vue'

export default {
  data() {
    return {
      Trophy,
      dispNum: 0,
      loading: false,
      userProfitloss: null,
      title: '',
      reduceDispNum(){
        this.dispNum = this.dispNum - 1
      },
      addComma(val) {
        let result = val.toLocaleString(undefined, { maximumFractionDigits: 20 })
        if (Math.sign(val) == 1) {
          result = `+${result}`
        }
        return result
      }
    }
  },
  async created() {
    await this.fetchAllUserRank(this.$route.params.survey_tool_id)
  },
  methods: {
    /************************
     *  survey_tool_idに当てはまる全てのユーザーの損益を取得
     ************************/
    async fetchAllUserRank(survey_tool_id) {
      this.loading = true
      const api = '/survey-tool/fetch-all-user-rank/' + survey_tool_id
      await axios.get(api)
        .then(res => {
          if (res.data.status == 'no_data') {
          // survey_tool_idが存在しない場合は404ページへ
            this.$router.push('/error')
          } else {
            if (res.data.status == 'no_finish') {
              this.$router.push(`/tools/survey-tool/${survey_tool_id}`)
            } else {
              this.title = res.data.title
              this.userProfitloss = res.data.user_prof
              this.dispNum = this.userProfitloss.length
              this.loading = false
            }
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
  },
  
}
</script>

<style scoped>
.sign1 {
  color: #EF5350;
}
.sign-1 {
  color: #42A5F5;
}
.sign0 {
  color: #66BB6A;
}
</style>

